// Example of pre-fetched price data (if available):
// window.preFetchedPrices = {
//   "Frame_Black_120_4_Oak": 439.00,
//   "Monitor_Bracket_FM-2": 62.99,
//   "Kabelgoot": 24.95,
//   // etc...
// };

function formatPrice(price) {
  return `€ ${price.toFixed(2).replace('.', ',')}`;
}

document.addEventListener("DOMContentLoaded", () => {
  const iframe = document.getElementById("api-frame");
  const client = new Sketchfab(iframe);

  // Object to track visibility state of nodes
  const nodeVisibility = {};

  // Mapping of frame, texture, and additional option prices with variant links
  const prices = {
    "Frame_Black_120_4_Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49206994010449",
    "Frame_Black_140_0_Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664312657",
    "Frame_Black_180_5_Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664378193",
    "Frame_White_120_11_Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49206994207057",
    "Frame_White_140_10_Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664443729",
    "Frame_White_180_9_Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664509265",
    "Frame_Black_120_4_White Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49206994043217",
    "Frame_Black_140_0_White Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664345425",
    "Frame_Black_180_5_White Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664410961",
    "Frame_White_120_11_White Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49206994239825",
    "Frame_White_140_10_White Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664476497",
    "Frame_White_180_9_White Oak": "https://douxe.net/products/elektrisch-zit-sta-bureau-ergonomisch?variant=49207664542033",
    // Existing monitor bracket mappings
    "Monitor_Bracket_FM-2": "https://douxe.net/products/monitorbeugel-voor-twee-beeldschermen-gasveer-fm-spm-2",
    "Monitor_Bracket_FM-1": "https://douxe.net/products/fm-spm1-gasveer-monitorbeugel",
    "Monitor_Bracket_SQ-2": "https://douxe.net/products/sq-2-dubbele-gasveer-monitorbeugel",
    
    // Monitor Brackets (new, updated)
    "Monitor_Bracket_Monitor_bracket_fm1_18": "https://douxe.net/products/fm-spm1-gasveer-monitorbeugel",
    "Monitor_Bracket_DXM-002_19": "https://douxe.net/products/monitor-beugel-voor-twee-schermen-dxm2",
    "Monitor_Bracket_DXM-003_20": "https://douxe.net/products/dxm3-triple-monitorbeugel",
    "Monitor_Bracket_DXM-004_21": "https://douxe.net/products/monitorbeugel-voor-vier-schermen-dxm-4",
    "Monitor_Bracket_DXM-001_22": "https://douxe.net/products/dxm-1-enkele-monitorbeugel",
    "Monitor_Bracket_SH-X6_23": "https://douxe.net/products/sh-x6-monitorbeugel",
    "Monitor_Bracket_SH-X7_25": "https://douxe.net/products/sh-x7-monitorbeugel",
    "Monitor_Bracket_SH-AMSP-02_24": "https://douxe.net/products/sh-amps-2-monitorbeugel",
    "Kabelgoot": "https://douxe.net/products/kabelgoot-organize",
  };

  // Simple cache for fetched prices
  const priceCache = {};

  // Modified fetchPrice now accepts an optional variantKey parameter
  const fetchPrice = async (url, variantKey) => {
    try {
      if (!url) throw new Error("URL is undefined");
      // Use pre-fetched price if available for this variant key
      if (window.preFetchedPrices && window.preFetchedPrices[variantKey] !== undefined) {
        console.log(`Using pre-fetched price for ${variantKey}: ${formatPrice(window.preFetchedPrices[variantKey])}`);
        return window.preFetchedPrices[variantKey];
      }
      // Return cached price if available
      if (priceCache[url] !== undefined) {
        console.log(`Using cached price for ${url}: ${formatPrice(priceCache[url])}`);
        return priceCache[url];
      }
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch price from ${url}`);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      const priceElement = doc.querySelector(".price__regular") || doc.querySelector(".price");
      if (!priceElement) throw new Error(`Price element not found on ${url}`);
      const priceMatch = priceElement.innerText.match(/(\d+[\.,]?\d*)/);
      if (!priceMatch) throw new Error(`Price not found in element text for ${url}`);
      const price = parseFloat(priceMatch[0].replace(",", "."));
      priceCache[url] = price; // Cache the result
      console.log(`Fetched price from ${url}: ${formatPrice(price)}`);
      return price;
    } catch (error) {
      console.error("Error fetching price:", error);
      return 0;
    }
  };

  // Calculate total price concurrently using Promise.all
  const calculateTotalPrice = async () => {
    const { frameKey, texture, selectedMonitorBracket, includeKabelgoot } = userSelection;
    console.log("Calculating total price with:", userSelection);
    console.log("Selected Monitor Bracket:", selectedMonitorBracket);

    const framePriceKey = `${frameKey}_${texture}`;
    const framePricePromise = prices[framePriceKey] ? fetchPrice(prices[framePriceKey], framePriceKey) : Promise.resolve(0);

    let monitorPricePromise = Promise.resolve(0);
    if (selectedMonitorBracket && selectedMonitorBracket.trim() !== "") {
      const monitorPriceKey = `Monitor_Bracket_${selectedMonitorBracket}`;
      monitorPricePromise = prices[monitorPriceKey]
        ? fetchPrice(prices[monitorPriceKey], monitorPriceKey)
        : Promise.resolve(0);
      if (!prices[monitorPriceKey]) {
        console.warn(`Monitor bracket price key "${monitorPriceKey}" not found.`);
      }
    }

    const kabelgootPricePromise = includeKabelgoot ? fetchPrice(prices["Kabelgoot"], "Kabelgoot") : Promise.resolve(0);

    const [framePrice, monitorPrice, kabelgootPrice] = await Promise.all([
      framePricePromise,
      monitorPricePromise,
      kabelgootPricePromise,
    ]);

    const unitPrice = framePrice + monitorPrice + kabelgootPrice;
    const quantity = Number(document.getElementById("quantityInput").value) || 1;
    const totalPrice = unitPrice * quantity;

    console.log(`Unit Price: ${formatPrice(unitPrice)} | Quantity: ${quantity} | Total Price: ${formatPrice(totalPrice)}`);
    return totalPrice;
  };

  const updatePriceDisplay = async () => {
    try {
      const totalPrice = await calculateTotalPrice();
      document.getElementById("priceValue").innerText = formatPrice(totalPrice);
    } catch (error) {
      console.error("Error updating price display:", error);
    }
  };

  const handleTextureChange = (texture) => {
    userSelection.texture = texture;
    updatePriceDisplay();
  };

  // Use existing userSelection if available; otherwise, initialize it.
  if (!window.userSelection) {
    window.userSelection = {
      frameKey: "Frame_Black_120_4",
      texture: "Oak",
      selectedMonitorBracket: "", // Default: no monitor bracket selected
      includeKabelgoot: false,    // Default value for Kabelgoot
    };
  }

  // Event listeners for frame selection
  document.getElementById("blackFrameDropdown").addEventListener("change", (e) => {
    userSelection.frameKey = e.target.value;
    updatePriceDisplay();
  });
  document.getElementById("whiteFrameDropdown").addEventListener("change", (e) => {
    userSelection.frameKey = e.target.value;
    updatePriceDisplay();
  });

  // Texture buttons
  document.getElementById("oakButton").addEventListener("click", () => {
    console.log("Switching to Oak texture");
    handleTextureChange("Oak");
  });
  document.getElementById("whiteOakButton").addEventListener("click", () => {
    console.log("Switching to White Oak texture");
    handleTextureChange("White Oak");
  });

  // Listen for the custom event dispatched by the monitor bracket dropdown
  document.addEventListener("monitorBracketChanged", updatePriceDisplay);

  // Kabelgoot toggle
  document.getElementById("cableTrayCheckbox").addEventListener("change", (e) => {
    userSelection.includeKabelgoot = e.target.checked;
    updatePriceDisplay();
  });

  // Use "input" event for quantity to update price immediately
  document.getElementById("quantityInput").addEventListener("input", updatePriceDisplay);

  // Initialize display on page load
  const initializeDisplay = () => {
    console.log("Initializing Price Display");
    updatePriceDisplay();
  };

  initializeDisplay();
});
